import { render, staticRenderFns } from "./ParteForm.vue?vue&type=template&id=1362a71e&"
import script from "./ParteForm.vue?vue&type=script&lang=js&"
export * from "./ParteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports